/**
 * MODULE: _shared/frontend-shell/src/hooks/useAssistantKeyboard.ts
 * PURPOSE: Global Cmd+K / Ctrl+K shortcut to open/focus assistant
 */

import { useEffect } from 'react';

const ASSISTANT_FOCUS_EVENT = 'assistant-focus-input';

export function dispatchAssistantFocus() {
  if (typeof document !== 'undefined') {
    document.dispatchEvent(new CustomEvent(ASSISTANT_FOCUS_EVENT));
  }
}

export function useAssistantFocusInput(callback: () => void) {
  useEffect(() => {
    const handler = () => callback();
    document.addEventListener(ASSISTANT_FOCUS_EVENT, handler);
    return () => document.removeEventListener(ASSISTANT_FOCUS_EVENT, handler);
  }, [callback]);
}
